import React, { useEffect, useRef, useState } from "react";
import {
  duplicate_plus,
  green_check,
  purple_excla,
  red_cross,
} from "../../../images";
import Select from "../../../library/components/Select/index";
import { TableWork } from "../../../ui";
import Button from "../../../library/components/Button";
import InputField from "../../../library/components/InputField";
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_INFO,
  BASE_URLS,
} from "../../../constants/constants";
import { createAlert } from "../../../features/alert/alerts";
import BarcodeReader from "react-barcode-reader";
import { TableLabel } from "./TableLabel";
import {
  useAddElectorMannualy13AMutation,
  useGetElectorQuery,
  useGetForm13aQuery,
  useGetForm13CQuery,
  useInvalid13AMutation,
  useScanner13AleftMutation,
  useScanner13ArightMutation,
} from "../../../services/preCountingServices";
import { Validators } from "../../../library/utilities/Validator";
import { Enter_Reason, FILED_IS_REQUIRED } from "../../../constants/constants";
import { useDispatch } from "react-redux";
import ConfirmationModal from "../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import CustomModal from "../../../library/components/Modal/modal";
import "./index.css";
import alertIcon from "../../../dashboardicon/alert.svg"
import { isValidFileNameFormARight, isValidFileNameFormBandFormAleft } from "../../utilities/utils";

export const FormA = ({
  isShowCameraPopup,
  onCameraPopopUpdate,
  onCameraPopopError,
  setonCameraPopopUpdate,
}) => {
  const [Data, setData] = useState([]);
  const [form13CState, setform13CState] = useState({
    isForm13CValid: true,
    form13CSrNo: "",
    form13CName: "",
  });
  const [isformADisable, setIsformADisable] = useState(false);
  const dispatch = useDispatch();
  const [electorDetail, setElectorDetail] = useState();
  const [selectedElector, setSelectedElector] = useState("");
  const [scanDataleft, setScanDataleft] = useState("");
  const [scanDataright, setScanDataright] = useState("");
  const [searchElector, setsearchElector] = useState("");
  const [skip, setskip] = useState(true);
  const { data: form13a, refetch } = useGetForm13aQuery();
  const { data: electordata } = useGetElectorQuery(searchElector, {
    skip: searchElector.length >= 3 ? false : skip,
  });
  const electorList = [];
  const [, setErrorValue] = useState({});
  const [tableBody, setTableBody] = useState([]);
  const [invalidReason, dataf] = useInvalid13AMutation();
  const [addElector, datae] = useAddElectorMannualy13AMutation();
  const [scanForm13Aleft, datap] = useScanner13AleftMutation();
  const [scanForm13Aright, datac] = useScanner13ArightMutation();
  const [isDuplicateAllowed, setisDuplicateAllowed] = useState("");
  const [remove, setRemove] = useState(false);
  const [error, setError] = useState(false);
  const [showConfirmationPopupLeft, setConfirmationPopupLeft] = useState(false);
  const [showConfirmationPopupRight, setConfirmationPopupRight] =
    useState(false);
  const [showConfirmationPopupInvalid, setConfirmationPopupInvalid] =
    useState(false);
    const [showePbIDCOnfirmation,setShowePbIDCOnfirmation]= useState(false)
  const { data: form13C } = useGetForm13CQuery();
  const [alertMessage, setAlertMessage] = useState(false);
  const [JunkalertMessage, setJunkAlertMessage] = useState(false);
  const [storedScanData,setStoredScanData] = useState("")
    const debounceTimeout = useRef(null);

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    setElectorDetail(form13C?.payload?.responseStatusForm13cDtoList?.[0]);
  }, [form13C]);

  useEffect(() => {
    let data = form13C?.payload?.responseStatusForm13cDtoList;
    if (data?.length > 0) {
      setform13CState({
        isForm13CValid: data?.[0]?.form13cScanStatus === "V",
        form13CSrNo: data?.[0]?.slNo13C,
        form13CName: data?.[0]?.fullName,
        epbID: data?.[0]?.epbId,
        fileName: data?.[0]?.fileName,
      });
      // if (
      //   data?.[0]?.form13cScanStatus === "V" &&
      //   form13a?.payload?.[0]?.slNo13A != data?.[0]?.slNo13C
      // ) {
      //   setIsformADisable(false);
      // }
      if (
        data?.[0]?.form13cScanStatus === "N" ||
        data?.[0]?.form13cScanStatus === "D" ||
        data?.[0]?.form13cScanStatus === "I"
      ) {
        setIsformADisable(true);
      }
      if (
        data?.[0]?.form13cScanStatus === "V" &&
        data?.[0]?.slNo13C == form13a?.payload?.[0]?.slNo13A &&
        form13a?.payload?.[0]?.form13aRcScanStatus != "" &&
        form13a?.payload?.[0]?.form13aLcScanStatus != ""
      ) {
        setIsformADisable(true);
      }
      if (
        data?.[0]?.form13cScanStatus === "V" &&
        data?.[0]?.slNo13C == form13a?.payload?.[0]?.slNo13A &&
        (form13a?.payload?.[0]?.form13aRcScanStatus === "N" ||
          form13a?.payload?.[0]?.form13aLcScanStatus === "N")
      ) {
        setIsformADisable(true);
      }
    } else {
      setIsformADisable(true);
    }
  }, [form13C, form13a]);

  useEffect(() => {
    let tData = [];
    form13a?.payload?.map((item, i) => {
      tData.push({
        "S.No": item.slNo13A,
        Elector: item.fullName,
        Status:
          item.form13aLcScanStatus === "V" ? (
            <TableLabel icon={green_check} color={"#24bc2a"} label={"Valid"} />
          ) : item.form13aLcScanStatus === "I" ? (
            <TableLabel
              icon={red_cross}
              color={"#E30000"}
              label={item.manualInvalidation}
            />
          ) : item.form13aLcScanStatus === "D" ? (
            <TableLabel
              icon={duplicate_plus}
              color={"#E66E00"}
              label={"Duplicate"}
            />
          ) : item.form13aLcScanStatus === "N" ||
            item.form13aRcScanStatus === "N" ? (
            <TableLabel
              icon={purple_excla}
              color={"#8D00BE"}
              label={
                item.form13aLcScanStatus === "V" ? "Valid" : item.leftMessage
              }
            />
          ) : null,

        Status1:
          item.form13aRcScanStatus === "V" ? (
            <TableLabel icon={green_check} color={"#24bc2a"} label={"Valid"} />
          ) : item.form13aRcScanStatus === "I" ? (
            <TableLabel
              icon={red_cross}
              color={"#E30000"}
              label={item.manualInvalidation}
            />
          ) : item.form13aRcScanStatus === "D" ? (
            <TableLabel
              icon={duplicate_plus}
              color={"#E66E00"}
              label={"Duplicate"}
            />
          ) : item.form13aLcScanStatus === "N" ||
            item.form13aRcScanStatus === "N" ? (
            <TableLabel
              icon={purple_excla}
              color={"#8D00BE"}
              label={
                item.form13aRcScanStatus === "V" ? "Valid" : item.rightMessage
              }
            />
          ) : null,
      });
      window.scrollTo(0, 0);
    });
    setTableBody(tData);
  }, [form13a]);

  electordata?.payload.map((item, i) => {
    electorList.push({
      ElectorId: item.electorId,
      label: `${item.fullName} / ${item.address}`,
    });
  });

  const handleChange = (key, value) => {
    if(key !=="Other Reason for Manual Invalidation OR Not Scanning"){
      setData((prevState) => ({
        ...prevState,
  
        ["Other_Reason"]:null,
      }));
    }
    setData((prevState) => ({
      ...prevState,

      [key]: value,
    }));
  };
  
  const onProceed = () => {
    setConfirmationPopupInvalid(false);
    setData((prev) => ({ ...prev, ["Selected_reason"]: "" }));
    if (Data.Selected_Reason) {
      if(Data.Selected_Reason=="Other Reason for Manual Invalidation OR Not Scanning" & (Data.Other_Reason==null||Data.Other_Reason==undefined||Data.Other_Reason=="")){
        onInfo("Please Enter the Reason for Manual Invalidation");
        return
      }
      invalidReason({
        invalidReason: Data.Other_Reason
          ? Data.Other_Reason
          : Data.Selected_Reason,
      }).then((res) => {
        refetch();
      });
      Data.Other_Reason = "".unwrap().then((res) => {
        refetch();
      });
    } else {
      onInfo("Select Reason for invalidation");
    }
    // setConfirmationPopupInvalid(false)
  };
  useEffect(() => {
    if (dataf.isError) {
      // onReject(dataf?.error?.data?.message);
    }
    if (dataf.isSuccess) {
      onSuccess(dataf?.data?.message);
    }
  }, [dataf.isError, dataf.isSuccess]);

  const getErrorValue = (key, value) => {
    setErrorValue((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };
  const data = {
    head: ["S. No.", "Elector", "ePBID-Scanned", "MREI-Scanned"],
    body: [{}],
  };
  const handlePbid = (key, value) => {
    setPBID({ ...PBID, [key]: "" + value });
    if (value.length >= 4) {
      // Check if it's not the last input field
      if (key !== "4") {
        // Get the next input field
        const nextSibling = document.querySelector(
          `input[name=in-${Number(key) + 1}]`
        );
        // If found, focus the next field
        if (nextSibling !== null) {
          nextSibling.focus();
        }
      }
    } else if (value.length == 0) {
      if (key != 0) {
        // Get the prev input field
        const prevSibling = document.querySelector(
          `input[name=in-${Number(key) - 1}]`
        );
        // If found, focus the next field
        if (prevSibling !== null) {
          prevSibling.focus();
        }
      }
    }
  };
  const initiPbid = {
    0: "",
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
    7: "",
  };
  const [PBID, setPBID] = useState({
    0: "",
    1: "",
    2: "",
    3: "",
  });
  const Adde_PBID = () => {
    setShowePbIDCOnfirmation(false)
    if (PBID[0] + PBID[1] + PBID[2] + PBID[3]) {
      addElector({
        id: electorDetail.id,
        fullName: electorDetail.fullName,
        address: electorDetail.address,
        epbId: PBID[0] + PBID[1] + PBID[2] + PBID[3],
        isFirstTimeScan: isDuplicateAllowed,
      })
        .unwrap()
        .then((res) => {
          if (res?.statusCode == 200) {
            if (res?.message?.includes("previously scanned")) {
              onInfo(res?.message);
            }
          } else {
            onInfo(res?.message);
          }
          refetch();
          window.scrollTo(0, 0);
          setElectorDetail("");
          setPBID(initiPbid);
        })
        .catch(() => {
          refetch();
          window.scrollTo(0, 0);
          setElectorDetail("");
          setPBID(initiPbid);
        });
    } else {
      onInfo("Please Enter EPB-id");
    }
  };
  useEffect(() => {
    if (datae.isError) {
      // onReject(datae?.error?.data?.message);
    }
    if (datae.isSuccess) {
      // onSuccess(datae?.data?.message);
    }
  }, [datae.isError, datae.isSuccess]);

  const listManualInvalidation = [
    {
      label:
        "Select Reason for Manual Invalidation/Not Scanning of not Scanning Form 13-A",
      value:
        "",
    },
    {
      label:
        " Form 13-A is not Found/Does not exist for the service voter (" +
        form13CState.form13CName +
        " of the current Form 13-C being Scanned)",
      value:
        "Form 13-A is not Found OR Does not exist for the service voter(" +
        form13CState.form13CName +
        " of the current Form 13-C being Scanned)",
    },
    {
      label: " Other Reason for Manual Invalidation/Not Scanning",
      value: "Other Reason for Manual Invalidation OR Not Scanning",
    },
  ];
  const myFunction = () => {
    document.getElementById("myDropdown").classList.toggle("show");
    document.getElementById('myInput').focus();
  };
  const filterFunction = () => {
    var input, filter, ul, li, a, i;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    var div = document.getElementById("myDropdown");
    a = div.getElementsByTagName("a");

    for (i = 0; i < a.length; i++) {
      var txtValue = a[i].textContent || a[i].innerText;
      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        a[i].style.display = "";
      } else {
        a[i].style.display = "none";
      }
    }
  };
  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };
 

  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "INFO",
      })
    );
  };
  const onReject = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_ERROR,
        heading: "Rejected",
      })
    );
  };
///////////////////////"Web Cam Code"

  // useEffect(() => {
  //   if (isShowCameraPopup && onCameraPopopUpdate) {
  //     handleScan(onCameraPopopUpdate);
  //     setonCameraPopopUpdate("");
  //   }
  // }, [onCameraPopopUpdate]);
  
  ////////////////////////////////////////////



  const handleScan = (data) => {

    setScanDataleft("");
    setScanDataright("");
    if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(() => {
          setJunkAlertMessage(false)
            setAlertMessage(true);
            setScanDataleft(""); // Clear the scan data
            setScanDataright("");
        }, 200); // Debounce time in milliseconds
    } else {
        debounceTimeout.current = setTimeout(() => {
            debounceTimeout.current = null; // Reset debounce timeout
            // setScanData(data);
            if (data.length == 16) {
              if(!isValidFileNameFormBandFormAleft(data,form13CState.epbID)){
               setStoredScanData(data);
                setJunkAlertMessage(true);
                return
              }else{
                setScanDataleft(data);
              }
            } else {
              if(!isValidFileNameFormARight(data,form13CState.fileName)){
                setStoredScanData(data);
                setJunkAlertMessage(true);
                return
              }else{
                setScanDataright(data);
              }
            }
            setAlertMessage(false); // Clear any previous alert
            // runApi(data); // Call the API directly here
        }, 450); // Debounce time in milliseconds
    }
  };
  const handleError = (err) => {
    console.error(err);
  };

  useEffect(() => {
    if (scanDataleft !== "") {
      setJunkAlertMessage(false);
      setStoredScanData("")
      debounceTimeout.current = null;
      scanForm13Aleft({
        epbId: scanDataleft,
        isFirstTimeScan: "",
      })
        .unwrap()
        .then((res) => {
          if (res?.statusCode == 200) {
            if (res?.message?.includes("previously scanned")) {
              onInfo(res?.message);
            } else if (res?.message?.includes("13-A Right QR code")) {
              setConfirmationPopupLeft(true);
            } else {
              onSuccess(res?.message);
            }
          } else {
            onInfo(res?.message);
          }
          refetch();
          window.scrollTo(0, 0);
        })
        .catch(() => {
          refetch();
          window.scrollTo(0, 0);
        });
    }
    // setScanDataleft("");
  }, [scanDataleft]);

  useEffect(() => {
    // if (datap.isError) {
    //   // onReject(datap?.error?.data?.message);
    // }
    // if (datap.isSuccess) {
    //   onSuccess(datap?.data?.message);
    // }
    // if (
    //   datap?.data?.message?.includes(
    //     "Duplicate scan detected against serial no"
    //   )
    // ) {
    //   onReject(datap?.data?.message);
    // }
  }, [datap.isError, datap.isSuccess]);

  useEffect(() => {
    if (scanDataright !== "") {
      setJunkAlertMessage(false);
      setStoredScanData("")
      debounceTimeout.current = null;
      scanForm13Aright({
        epbFileName: scanDataright,
        isFirstTimeScan: "",
      })
        .unwrap()
        .then((res) => {
          if (res?.statusCode == 200) {
            if (res?.message?.includes("previously scanned")) {
              onInfo(res?.message);
            } else if (res?.message?.includes("13-A Left QR code")) {
              setConfirmationPopupRight(true);
            } else {
              onSuccess(res?.message);
            }
          } else {
            onInfo(res?.message);
          }
          refetch();
          window.scrollTo(0, 0);
        })
        .catch(() => {
          refetch();
          window.scrollTo(0, 0);
        });
    }
    // setScanDataright("");
  }, [scanDataright]);

  useEffect(() => {
    // if (datac.isError) {
    //   // onReject(datac?.error?.data?.message);
    // }
    // if (datac.isSuccess && datac?.data?.message !== "Duplicate Scan") {
    //   onSuccess(datac?.data?.message);
    // }
    // if (
    //   datac?.data?.message?.includes(
    //     "previously scanned"
    //   )
    // ) {
    //   onReject(datap?.data?.message)
    // }
  }, [datac.isError, datac.isSuccess]);

  const onClose = () => {
    setConfirmationPopupLeft(false);
    setConfirmationPopupRight(false);
    setScanDataright("");
    setScanDataleft("");
  };

  const onCloseEPBConfirmation = () =>{
    setShowePbIDCOnfirmation(false)
  }
  const onCloseLeft = () => {
    scanForm13Aleft({
      epbId: scanDataleft,
      isFirstTimeScan: "No",
    }).then((res) => {
      refetch();
    });
    setRemove(false);
    setConfirmationPopupLeft(false);
    setScanDataleft("");
  };
  const onCloseRight = () => {
    scanForm13Aright({
      epbFileName: scanDataright,
      isFirstTimeScan: "No",
    }).then((res) => {
      refetch();
    });
    setRemove(false);
    setConfirmationPopupRight(false);
    setScanDataright("");
  };
  const onCloseInvalid = () => {
    setData((prev) => ({ ...prev, ["Selected_reason"]: "" }));
    setConfirmationPopupInvalid(false);
    // invalidReason("");
  };

  const righReset = (event) => {
    scanForm13Aright({
      epbFileName: scanDataright,
      isFirstTimeScan: "Yes",
    }).then((res) => {
      refetch();
    });
    setRemove(false);
    setConfirmationPopupRight(false);
    setScanDataright("");
  };
  const leftReset = (event) => {
    scanForm13Aleft({
      epbId: scanDataleft,
      isFirstTimeScan: "Yes",
    }).then((res) => {
      refetch();
    });
    setRemove(false);
    setConfirmationPopupLeft(false);
    setScanDataleft("");
  };

  const confirmationForProceed = () => {
    setConfirmationPopupInvalid(true);
  };
  //////////////////////////EPB ID DELETE CODE
  const handlesubmit = (e, data) => {
    e.preventDefault();
  };

  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {
      const next = elmnt.target.tabIndex;
      if (next < 4) {
        elmnt.target.form.elements[next].focus();
      }
    }
  };

  return (
    <>
    {
        <CustomModal
          className="confirmation_modal"
          show={JunkalertMessage}
          // onClose={()=>{setJunkAlertMessage(false)}}
          closeIcon={false}
          size="700px"
          modalTitle={<>
            <div style={{display:"flex"}}><img src={alertIcon} style={{marginRight:"10px",height:"30px",width:"30px"}} /><h3 style={{color:"red"}}>Alert : Please read carefully !</h3></div>
        <hr/>
          </>
          }
          children={  
            <>
             <p style={{fontSize:"17px" ,marginBottom:"40px"}}>Your QR Code Scanner has returned invalid value, or you must have scanned wrong QR Code. You may try to scan again, or reset your QR Code scanner or replace the Computer or add manually.<br/> If you want to scan again or add manually click on <span style={{backgroundColor:"#007bff", padding:"2px", borderRadius:"2px",color:"white",fontWeight:600}}>"Scan Again/Add Manually"</span> else click on <span style={{backgroundColor:"#ffc107", padding:"2px", borderRadius:"2px",color:"black",fontWeight:600}}>"Proceed With The Scanned Value"</span> to proceed with the value that you have scanned.<br/><span style={{ color:"red"}}> Note that if you proceed with the scanned value, the system will mark it as invalid.</span></p>
            <button type="button" className="btn btn-warning" onClick={()=>{
if(storedScanData.length==16){
setScanDataleft(storedScanData)
}else{
setScanDataright(storedScanData)
};
}} style={{
              float:"left",
              margin:"15px"
            }}>Proceed With The Scanned Value</button>
            <button type="button" className="btn btn-primary" onClick={()=>{
           setJunkAlertMessage(false);
           setStoredScanData("");
            }} style={{
              float:"right",
              margin:"15px"
            }}>Scan Again/Add Manually</button>
            </>
          }         
        />
      }
     {
        <CustomModal
          className="confirmation_modal"
          show={alertMessage}
          onClose={()=>{setAlertMessage(false);
          setScanDataleft("");
          setScanDataright("")
          debounceTimeout.current = null
          }}
          closeIcon={false}
          size="700px"
          modalTitle={<>
            <div style={{display:"flex"}}><img src={alertIcon} style={{marginRight:"10px",height:"30px",width:"30px"}} /><h3 style={{color:"red"}}>Alert : Please read carefully !</h3></div>
        <hr/>
          </>
          }
          children={  
            <>
            <p style={{fontSize:"17px"}}>Your QR Code Scanner has returned multiple values, it should return only one value at a time. You may try to scan again, or reset your QR Code scanner or replace the Computer. In case the QR Code returns multiple values, keep on scanning again or try on another computer with your own login id. If it still persist, you may add manually.</p>
            <button type="button" className="btn btn-primary" onClick={()=>{
              setAlertMessage(false);
              setScanDataleft("");
              setScanDataright("")
              debounceTimeout.current = null
            }} style={{
              float:"right",
              margin:"15px"
            }}>OK</button>
            </>
          }         
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopupLeft}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={
            "Are you sure you are scanning the correct Form 13-A Right QR code ?"
          }
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={onCloseLeft}
              yesOption={leftReset}
            />
          }
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopupRight}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={
            "Are you sure you are scanning the correct Form 13-A Left QR code ?"
          }
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={onCloseRight}
              yesOption={righReset}
            />
          }
        />
      }
      {
        <CustomModal
          className="confirmation_modal"
          show={showConfirmationPopupInvalid}
          onClose={onClose}
          size="500px"
          closeIcon={false}
          modalTitle={"Do you want to Invalidate this Record ?"}
          children={
            <ConfirmationModal
              // title="You want to delete this"
              noOption={onCloseInvalid}
              yesOption={onProceed}
            />
          }
        />
      }
      {
          <CustomModal
          className="confirmation_modal"
          show={showePbIDCOnfirmation}
          // onClose={onCloseEPBConfirmation}
          size="500px"
          closeIcon={false}
          modalTitle={
            "Are you sure you have entered the correct e-PB id as on FORM 13-A ?"
          }
          children={
            <div>
             <div style={{paddingBottom:"30px"}}>
             <span style={{fontSize: "18px",
    color: "red",
    fontWeight: 700,}}>ePB-Id: </span><span style={{fontSize: "30px",
    color: "black",
    fontWeight: 700,
    fontFamily: "monospace",
    paddingLeft: "24px",}}>{PBID[0].toUpperCase()}-{PBID[1].toUpperCase()}-{PBID[2].toUpperCase()}-{PBID[3].toUpperCase()}</span>
             </div>
    <ConfirmationModal
              // title="You want to delete this"
              noOption={()=>setShowePbIDCOnfirmation(false)}
              yesOption={Adde_PBID}
            />
            </div>
          }
        />
      }
      <BarcodeReader onError={handleError} onScan={handleScan} />
      <div className="form-default formA_table_default">
        <div className="head-title mb-3">
          <div className="for_pbid mb-2">
            <div className="row ">
              <strong className="col-md-3">
                Reason for manual invalidation / not scanning
              </strong>

              <div className="row col-md-7">
                <Select
                  placeholder="Select Reason for manual invalidation / not scanning"
                  labelClass=""
                  inputClass="col-md-12"
                  value={Data.Selected_Reason}
                  options={listManualInvalidation}
                  disabled={isformADisable}
                  selectClass="select-class"
                  handleChange={(val) => handleChange("Selected_Reason", val)}
                />
                {Data.Selected_Reason ===
                  "Other Reason for Manual Invalidation OR Not Scanning" && (
                  <InputField
                    name="Other_Reason"
                    placeholder="Enter the Reason for Manual Invalidation"
                    required={true}
                    inputClass="col-md-12"
                    labelClass=""
                    value={Data.Other_Reason}
                    disabled={isformADisable}
                    onChange={(val) => handleChange("Other_Reason", val)}
                    getError={(value) => getErrorValue("Other_Reason", value)}
                    validators={[
                      // {
                      //   check: Validators.textinput,
                      //   message: Enter_Reason,
                      // },
                      {
                        check: Validators.required,
                        message: FILED_IS_REQUIRED,
                      },
                    ]}
                  />
                )}
              </div>
              <Button
                value="Proceed"
                onClick={confirmationForProceed}
                disabled={isformADisable}
                btnClass="proceed-btn"
              />
            </div>
          </div>
          <div className="for_pbid mb-2">
            <strong className="mr-1">Add Elector Manually</strong>
            <div class="dropdownn col-md-9">
              <button
                onClick={() => myFunction()}
                disabled={isformADisable}
                class="dropbtn col-md-9 addElectorDropdown"
              >
                {/* {electorDetail
                  ? `${electorDetail.fullName} / ${electorDetail.address}`
                  : ""} */}
                {selectedElector
                  ? `${selectedElector?.fullName} /  ${selectedElector?.address}`
                  : ""}
              </button>
              <div id="myDropdown" class="dropdownn-content">
                <input
                  type="text"
                  placeholder="Type here atleast 3 char.. (i.e dem)"
                  style={{}}
                  id="myInput"
                  onKeyUp={() => {
                    filterFunction();
                  }}
                  onChange={(e) => setsearchElector(e.target.value)}
                />
                {electordata?.payload?.map((item) => {
                  if (electorDetail.id == item.id) {
                    return (
                      <a
                        href="#about"
                        id={JSON.stringify({
                          id: item.id,
                          fullName: item.fullName,
                          epbId: item.epbId,
                          address: item.address,
                        })}
                        onClick={(e) => {
                          var contentId = JSON.parse(
                            e.target.getAttribute("id")
                          );
                          setSelectedElector(contentId);
                          myFunction();
                        }}
                      >
                        {`${item.fullName} / ${item.address}`}
                      </a>
                    );
                  }
                })}
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: "-15px",
              fontSize: "13px",
              marginBottom: "5px",
            }}
          >
            (in case QR Code is not scanned)
          </div>
          <span className="headingpreCounting mb-2">
            <strong className="mr-1">Enter e-PBID Manually </strong>
          </span>
          <div className="add-elector">
            {/* <form className="form_align"> */}
            {[0, 1, 2, 3].map((inputItem) => (
              <InputField
                name={"in-" + inputItem}
                maxLength={4}
                onChange={(value) => handlePbid(inputItem, value)}
                inputClass="input-class"
                disabled={isformADisable}
                value={PBID[inputItem]}
                onKeyUp={(e) => inputfocus(e)}
                onKeyPress={(evt) => [" "].includes(evt.key) && evt.preventDefault()}
                // inputClass="mr-2"
              />
            ))}
            {/* </form> */}

            <Button
              fa_icon="fa-plus plus-icon"
              onClick={()=>{ if (PBID[0].length==4 && PBID[1].length==4 && PBID[2].length==4 && PBID[3].length==4){
                setShowePbIDCOnfirmation(true)
              }else{
                onInfo("Please Enter 16 digit EPB-id")
              }}}
              value="Add"
              disabled={isformADisable || electordata?.statusCode !=200}
              btnClass="add-button"
            />

            <Button
              value="Reset"
              btnClass="reset-button"
              disabled={isformADisable}
              onClick={() => setPBID(initiPbid)}
            />
          </div>
        </div>
        <TableWork
          id=""
          theadData={data.head}
          tbodyData={tableBody}
          anchorTagName=""
          anchorTagclassName="viewDetails"
          emptyMessage="No data found"
          pageSize={10}
          pagination={true}
          paginationClass={"text-right p-0"}
        />
      </div>
    </>
  );
};
